import { log } from "console";
import * as ApiConfig from "../config/API";

import { AuthInterceptor } from "../utils/fetch-utils";
import { useAuthStore } from "@/store/authStore";

export class JmApi {
  keycloakObj: any;

  constructor(keycloakObj: any) {
    const authStore = useAuthStore();
    authStore.getKeycloakObj;
    this.keycloakObj = keycloakObj;
    AuthInterceptor(this.keycloakObj);
  }
  // function-collection for interacting with the JM API

  static async post(url: string, body: object): Promise<object> {
    // console.log("post in jm-api.ts called");
    const authStore = useAuthStore();

    const keycloakObj = authStore.getKeycloakObj;
    const unregister = AuthInterceptor(keycloakObj);
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apiKey: ApiConfig.KEY,
          accept: "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (response.ok) {
            if (response.status === 204) {
              resolve({});
            } else {
              response
                .json()
                .then(resolve)
                .catch((error) => {
                  // Handle JSON parsing errors for successful responses
                  console.error(
                    "Error parsing JSON from successful response:",
                    error,
                  );
                  reject(new Error("Invalid JSON in response"));
                });
            }
          } else {
            // Handle error responses
            response
              .text()
              .then((text) => {
                try {
                  // Try to parse as JSON first
                  const data = JSON.parse(text);
                  reject(data);
                } catch (e) {
                  // If not valid JSON, return the text with status
                  reject(
                    new Error(
                      `Server error (${response.status}): ${text || response.statusText}`,
                    ),
                  );
                }
              })
              .catch(() => {
                // If we can't even get the text, reject with status
                reject(
                  new Error(
                    `Server error (${response.status}): ${response.statusText}`,
                  ),
                );
              });
          }
          // response.json().then((data) => {
          //   if (data["success"] === false || data[204] === false) {
          //     reject(data);
          //   } else {
          //     resolve(data);
          //   }
          // });
        })
        .catch((error) => {
          // Handle network errors
          console.error("Network error in POST request:", error);
          reject(error);
        })
        .finally(() => unregister());
    });
  }

  static async get(url: string): Promise<object[]> {
    // console.log("get in jm-api.ts called");
    const authStore = useAuthStore();

    const keycloakObj = authStore.getKeycloakObj;
    const unregister = AuthInterceptor(keycloakObj);
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        headers: {
          apiKey: ApiConfig.KEY,
          accept: "application/json",
        },
      })
        .then((response) => {
          response.json().then((data) => {
            if (data["success"] === false) {
              reject(data);
            } else {
              resolve(data);
            }
          });
        })
        .finally(() => unregister());
    });
  }

  static async post_download(url: string, body: object): Promise<Blob> {
    const authStore = useAuthStore();
    const keycloakObj = authStore.getKeycloakObj;
    const unregister = AuthInterceptor(keycloakObj);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apiKey: ApiConfig.KEY,
          accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error(
          `Download failed: ${response.status} ${response.statusText}`,
        );
      }

      return await response.blob();
    } catch (error) {
      console.error("Error in post_download:", error);
      throw error;
    } finally {
      unregister();
    }
  }

  static async get_download(url: string, isBlob = false): Promise<any> {
    const authStore = useAuthStore();

    const keycloakObj = authStore.getKeycloakObj;
    const unregister = AuthInterceptor(keycloakObj);
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        headers: {
          apiKey: ApiConfig.KEY,
          accept: isBlob ? "application/octet-stream" : "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            if (isBlob) {
              resolve(response.blob());
            } else {
              response.json().then(resolve, reject);
            }
          } else {
            response.json().then(reject);
          }
        })
        .catch(reject)
        .finally(() => unregister());
    });
  }

  static async put(url: string, body: object): Promise<object> {
    const authStore = useAuthStore();

    const keycloakObj = authStore.getKeycloakObj;
    const unregister = AuthInterceptor(keycloakObj);
    // console.log("PUT-Body: ", body);
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          apiKey: ApiConfig.KEY,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) =>
          response.json().then((data) => {
            if (data["success"] === false) {
              reject(data);
            } else {
              resolve(data);
            }
          }),
        )
        .finally(() => unregister());
    });
  }

  static delete(url: string, body?: object): Promise<object> {
    const authStore = useAuthStore();

    const keycloakObj = authStore.getKeycloakObj;
    const unregister = AuthInterceptor(keycloakObj);
    // console.log("Delete URL: ", url);
    // if (body) console.log("Delete Body: ", body);

    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "DELETE",
        headers: {
          accept: "application/json",
          apiKey: ApiConfig.KEY,
          ...(body && { "Content-Type": "application/json" }),
        },
        ...(body && { body: JSON.stringify(body) }),
      })
        .then((response) => {
          const contentType = response.headers.get("content-type") || "";
          const contentLength = response.headers.get("content-length");
          const hasJsonContentType = contentType.includes("application/json");
          const hasBody = contentLength !== "0" && response.status !== 204 && response.status !== 205;

          if (!response.ok) {
            response
              .text()
              .then((text) => {
                if (hasJsonContentType && text) {
                  try {
                    reject(JSON.parse(text));
                    return;
                  } catch (_) {
                    // Fall through to generic error below.
                  }
                }
                reject(
                  new Error(
                    `Server error (${response.status}): ${text || response.statusText}`,
                  ),
                );
              })
              .catch(() => {
                reject(
                  new Error(
                    `Server error (${response.status}): ${response.statusText}`,
                  ),
                );
              });
            return;
          }

          if (!hasBody) {
            resolve({});
            return;
          }

          if (hasJsonContentType) {
            response
              .json()
              .then((data) => resolve(data ?? {}))
              .catch(() => resolve({}));
            return;
          }

          response
            .text()
            .then((text) => resolve(text ? ({ message: text } as object) : {}))
            .catch(() => resolve({}));
        })
        .catch((error) => {
          console.error("Error in DELETE request:", error);
          reject(error);
        })
        .finally(() => unregister());
    });
  }

  static async uploadFile(
    url: string,
    file: File,
    params: Record<string, any> = {},
  ): Promise<object> {
    const authStore = useAuthStore();
    const keycloakObj = authStore.getKeycloakObj;
    const unregister = AuthInterceptor(keycloakObj);
    console.log("Uploading file:", file);
    // console.log("Params:", params);
    // console.log("URL:", url);

    try {
      // Create FormData object
      const formData = new FormData();
      formData.append("file", file);

      // Add query parameters to URL
      const queryParams = new URLSearchParams();
      for (const [key, value] of Object.entries(params)) {
        queryParams.append(key, String(value));
      }

      const fullUrl = `${url}?${queryParams.toString()}`;

      console.log("Full URL:", fullUrl);

      // Send the request
      const response = await fetch(fullUrl, {
        method: "POST",
        headers: {
          apiKey: ApiConfig.KEY,
          // Don't set Content-Type for FormData - it will be set automatically with boundary
        },
        body: formData,
      });
      console.log("Upload response status:", response.status);
      // console.log("Response headers:", Object.fromEntries([...response.headers]),);

      // Handle the response
      if (!response.ok) {
        // Try to get error details
        let errorMessage;
        try {
          const errorText = await response.text();
          console.error("Error response text:", errorText);

          try {
            const errorData = JSON.parse(errorText);
            errorMessage =
              errorData.message ||
              `HTTP Error: ${response.status} ${response.statusText}`;
          } catch {
            errorMessage = `HTTP Error: ${response.status} ${response.statusText}. Response: ${errorText}`;
          }
        } catch (parseError) {
          console.error("Error parsing response:", parseError);
          errorMessage = `HTTP Error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      return await response.json();
    } finally {
      unregister();
    }
  }
}
